import React from 'react'

export default function RedactPdf(props) {
  const { className } = props

  return (
    <div className={className ? className : ''}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 32 36"
      >
        <path
          fill="currentColor"
          fill-opacity=".1"
          d="M22.4 1c.5 0 1.1.2 1.4.6l6.1 6c.3.4.5.9.5 1.5v23.2c0 1.8-1.5 3.2-3.2 3.2h-22C3.4 35.5 2 34 2 32.3v-28C2 2.5 3.4 1 5.2 1h17.2Zm1.19 9A4.585 4.585 0 0 0 19 14.58c0 2.53 2.055 4.58 4.59 4.58 2.535 0 4.59-2.05 4.59-4.58 0-2.53-2.055-4.58-4.59-4.58Z"
        />
        <path
          fill="currentColor"
          d="M30.14 6.8 23.735.6c-.4-.4-.9-.6-1.5-.6H4.321A3.373 3.373 0 0 0 .92 3.4v29.2c0 1.9 1.5 3.4 3.402 3.4h23.116c1.9 0 3.402-1.5 3.402-3.3V8.5c0-.7-.2-1.3-.7-1.7Zm-.5 24.9c0 1.7-1.402 3.2-3.103 3.2H5.223c-1.701 0-3.102-1.4-3.102-3.2V4.3c0-1.7 1.4-3.2 3.102-3.2h16.51c.501 0 1.002.2 1.402.6l5.904 5.8c.4.4.7 1 .6 1.6l.001 22.6Z"
        />
        <path
          fill="currentColor"
          d="M26.76 14.62c0-1.722-1.4-3.12-3.13-3.12-.292 0-.583.04-.862.12l3.03 5.247a3.104 3.104 0 0 0 .962-2.247Zm-4.902-2.573A3.128 3.128 0 0 0 20.5 14.62a3.125 3.125 0 0 0 4.47 2.815l-3.112-5.39Zm5.902 2.573c0 2.278-1.85 4.12-4.13 4.12a4.125 4.125 0 0 1-4.13-4.12l.005-.204a4.126 4.126 0 0 1 4.125-3.915c2.28 0 4.13 1.842 4.13 4.12Z"
        />
        <path
          fill="currentColor"
          d="M26.154 21c.467 0 .846.224.846.5s-.379.5-.846.5H5.846C5.38 22 5 21.776 5 21.5s.379-.5.846-.5h20.308Z"
        />
        <path
          fill="currentColor"
          fill-opacity=".5"
          d="m20.5 18 1.5 1H5.846C5.38 19 5 18.776 5 18.5s.379-.5.846-.5H20.5Z"
        />
        <path
          fill="currentColor"
          d="M13.654 15c.191 0 .346.224.346.5s-.155.5-.346.5H5.346C5.155 16 5 15.776 5 15.5s.155-.5.346-.5h8.308Z"
        />
        <path
          fill="currentColor"
          fill-opacity=".5"
          d="M19 15v.5l.231.5h-2.808c-.234 0-.423-.224-.423-.5s.19-.5.423-.5H19Zm-.538-3c.297 0 .538.224.538.5s-.241.5-.538.5H5.538C5.241 13 5 12.776 5 12.5s.241-.5.538-.5h12.924Z"
        />
        <path
          fill="currentColor"
          d="M8.846 9c.085 0 .154.224.154.5s-.069.5-.154.5H5.154C5.069 10 5 9.776 5 9.5s.069-.5.154-.5h3.692Zm17.539 0c.34 0 .615.224.615.5s-.276.5-.615.5h-14.77c-.34 0-.615-.224-.615-.5s.275-.5.615-.5h14.77Z"
        />
      </svg>
    </div>
  )
}
